app.filter('unique', function() {
    return function(collection, keyname) {

          var output = [], 
          keys = [];
      
      angular.forEach(collection, function(item) {
          var key = keyname.split('.').reduce(index, item)          
          if(keys.indexOf(key) === -1) {
              keys.push(key); 
              output.push(item);
          }
      });

      return output;
   };

function index(obj,i) {return obj[i]}
});